"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFTCollectionFactory = void 0;
/**
 * This code was generated by generateTsPackage.
 * Do not edit it manually
 */
exports.NFTCollectionFactory = [
    {
        inputs: [
            { internalType: 'address', name: 'router', type: 'address' },
            {
                components: [
                    {
                        components: [
                            {
                                internalType: 'address',
                                name: 'implementation',
                                type: 'address',
                            },
                            {
                                internalType: 'uint256',
                                name: 'templateVersion',
                                type: 'uint256',
                            },
                        ],
                        internalType: 'struct NFTCollectionFactorySharedTemplates.CollectionTemplateDetails',
                        name: 'nftCollection',
                        type: 'tuple',
                    },
                    {
                        components: [
                            {
                                internalType: 'address',
                                name: 'implementation',
                                type: 'address',
                            },
                            {
                                internalType: 'uint256',
                                name: 'templateVersion',
                                type: 'uint256',
                            },
                        ],
                        internalType: 'struct NFTCollectionFactorySharedTemplates.CollectionTemplateDetails',
                        name: 'nftDropCollection',
                        type: 'tuple',
                    },
                    {
                        components: [
                            {
                                internalType: 'address',
                                name: 'implementation',
                                type: 'address',
                            },
                            {
                                internalType: 'uint256',
                                name: 'templateVersion',
                                type: 'uint256',
                            },
                        ],
                        internalType: 'struct NFTCollectionFactorySharedTemplates.CollectionTemplateDetails',
                        name: 'nftTimedEditionCollection',
                        type: 'tuple',
                    },
                    {
                        components: [
                            {
                                internalType: 'address',
                                name: 'implementation',
                                type: 'address',
                            },
                            {
                                internalType: 'uint256',
                                name: 'templateVersion',
                                type: 'uint256',
                            },
                        ],
                        internalType: 'struct NFTCollectionFactorySharedTemplates.CollectionTemplateDetails',
                        name: 'nftLimitedEditionCollection',
                        type: 'tuple',
                    },
                    {
                        components: [
                            {
                                internalType: 'address',
                                name: 'implementation',
                                type: 'address',
                            },
                            {
                                internalType: 'uint256',
                                name: 'templateVersion',
                                type: 'uint256',
                            },
                        ],
                        internalType: 'struct NFTCollectionFactorySharedTemplates.CollectionTemplateDetails',
                        name: 'multiTokenCollection',
                        type: 'tuple',
                    },
                ],
                internalType: 'struct NFTCollectionFactorySharedTemplates.CollectionTemplates',
                name: 'collectionTemplates',
                type: 'tuple',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        inputs: [
            { internalType: 'address', name: 'addressReturned', type: 'address' },
        ],
        name: 'AddressLibrary_Proxy_Call_Did_Not_Return_A_Contract',
        type: 'error',
    },
    { inputs: [], name: 'ERC1167FailedCreateClone', type: 'error' },
    {
        inputs: [],
        name: 'NFTCollectionFactoryCollectionTypes_Collection_Type_Is_Null',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTCollectionFactorySharedTemplates_Implementation_Not_A_Contract',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTCollectionFactorySharedTemplates_Invalid_Collection_Type',
        type: 'error',
    },
    {
        inputs: [],
        name: 'RouterContextSingle_Address_Is_Not_A_Contract',
        type: 'error',
    },
    {
        inputs: [],
        name: 'StringsLibrary_Required_String_Is_Empty',
        type: 'error',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: false, internalType: 'uint8', name: 'version', type: 'uint8' },
        ],
        name: 'Initialized',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'collection',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'creator',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'templateVersion',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'contractCreationNonce',
                type: 'uint256',
            },
        ],
        name: 'MultiTokenCollectionCreated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'collection',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'creator',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'templateVersion',
                type: 'uint256',
            },
            { indexed: false, internalType: 'string', name: 'name', type: 'string' },
            {
                indexed: false,
                internalType: 'string',
                name: 'symbol',
                type: 'string',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'contractCreationNonce',
                type: 'uint256',
            },
        ],
        name: 'NFTCollectionCreated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'collection',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'creator',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'approvedMinter',
                type: 'address',
            },
            { indexed: false, internalType: 'string', name: 'name', type: 'string' },
            {
                indexed: false,
                internalType: 'string',
                name: 'symbol',
                type: 'string',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'baseURI',
                type: 'string',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'isRevealed',
                type: 'bool',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'maxTokenId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'paymentAddress',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'templateVersion',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'contractCreationNonce',
                type: 'uint256',
            },
        ],
        name: 'NFTDropCollectionCreated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'collection',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'creator',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'approvedMinter',
                type: 'address',
            },
            { indexed: false, internalType: 'string', name: 'name', type: 'string' },
            {
                indexed: false,
                internalType: 'string',
                name: 'symbol',
                type: 'string',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'tokenURI',
                type: 'string',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'maxTokenId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'paymentAddress',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'templateVersion',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'contractCreationNonce',
                type: 'uint256',
            },
        ],
        name: 'NFTLimitedEditionCollectionCreated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'collection',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'creator',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'approvedMinter',
                type: 'address',
            },
            { indexed: false, internalType: 'string', name: 'name', type: 'string' },
            {
                indexed: false,
                internalType: 'string',
                name: 'symbol',
                type: 'string',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'tokenURI',
                type: 'string',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'mintEndTime',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'paymentAddress',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'templateVersion',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'contractCreationNonce',
                type: 'uint256',
            },
        ],
        name: 'NFTTimedEditionCollectionCreated',
        type: 'event',
    },
    {
        inputs: [
            { internalType: 'uint96', name: 'contractCreationNonce', type: 'uint96' },
            { internalType: 'string', name: 'contractURI', type: 'string' },
            {
                internalType: 'bytes[]',
                name: 'collectionContractInternalDelegateCalls',
                type: 'bytes[]',
            },
            {
                components: [
                    { internalType: 'address', name: 'target', type: 'address' },
                    { internalType: 'bytes', name: 'callData', type: 'bytes' },
                ],
                internalType: 'struct CallWithoutValue[]',
                name: 'externalCalls',
                type: 'tuple[]',
            },
        ],
        name: 'createMultiTokenCollection',
        outputs: [{ internalType: 'address', name: 'collection', type: 'address' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'name', type: 'string' },
            { internalType: 'string', name: 'symbol', type: 'string' },
            { internalType: 'uint96', name: 'contractCreationNonce', type: 'uint96' },
        ],
        name: 'createNFTCollection',
        outputs: [{ internalType: 'address', name: 'collection', type: 'address' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'name', type: 'string' },
            { internalType: 'string', name: 'symbol', type: 'string' },
            { internalType: 'string', name: 'baseURI', type: 'string' },
            { internalType: 'bool', name: 'isRevealed', type: 'bool' },
            { internalType: 'uint32', name: 'maxTokenId', type: 'uint32' },
            { internalType: 'address', name: 'approvedMinter', type: 'address' },
            { internalType: 'uint96', name: 'contractCreationNonce', type: 'uint96' },
        ],
        name: 'createNFTDropCollection',
        outputs: [{ internalType: 'address', name: 'collection', type: 'address' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'name', type: 'string' },
            { internalType: 'string', name: 'symbol', type: 'string' },
            { internalType: 'string', name: 'baseURI', type: 'string' },
            { internalType: 'bool', name: 'isRevealed', type: 'bool' },
            { internalType: 'uint32', name: 'maxTokenId', type: 'uint32' },
            { internalType: 'address', name: 'approvedMinter', type: 'address' },
            { internalType: 'uint96', name: 'contractCreationNonce', type: 'uint96' },
            {
                internalType: 'address payable',
                name: 'paymentAddress',
                type: 'address',
            },
        ],
        name: 'createNFTDropCollectionWithPaymentAddress',
        outputs: [{ internalType: 'address', name: 'collection', type: 'address' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'name', type: 'string' },
            { internalType: 'string', name: 'symbol', type: 'string' },
            { internalType: 'string', name: 'baseURI', type: 'string' },
            { internalType: 'bool', name: 'isRevealed', type: 'bool' },
            { internalType: 'uint32', name: 'maxTokenId', type: 'uint32' },
            { internalType: 'address', name: 'approvedMinter', type: 'address' },
            { internalType: 'uint96', name: 'contractCreationNonce', type: 'uint96' },
            {
                components: [
                    { internalType: 'address', name: 'target', type: 'address' },
                    { internalType: 'bytes', name: 'callData', type: 'bytes' },
                ],
                internalType: 'struct CallWithoutValue',
                name: 'paymentAddressFactoryCall',
                type: 'tuple',
            },
        ],
        name: 'createNFTDropCollectionWithPaymentFactory',
        outputs: [{ internalType: 'address', name: 'collection', type: 'address' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'name', type: 'string' },
            { internalType: 'string', name: 'symbol', type: 'string' },
            { internalType: 'string', name: 'tokenURI', type: 'string' },
            { internalType: 'uint32', name: 'maxTokenId', type: 'uint32' },
            { internalType: 'address', name: 'approvedMinter', type: 'address' },
            { internalType: 'uint96', name: 'contractCreationNonce', type: 'uint96' },
        ],
        name: 'createNFTLimitedEditionCollection',
        outputs: [{ internalType: 'address', name: 'collection', type: 'address' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'name', type: 'string' },
            { internalType: 'string', name: 'symbol', type: 'string' },
            { internalType: 'string', name: 'tokenURI', type: 'string' },
            { internalType: 'uint32', name: 'maxTokenId', type: 'uint32' },
            { internalType: 'address', name: 'approvedMinter', type: 'address' },
            { internalType: 'uint96', name: 'contractCreationNonce', type: 'uint96' },
            {
                internalType: 'address payable',
                name: 'paymentAddress',
                type: 'address',
            },
        ],
        name: 'createNFTLimitedEditionCollectionWithPaymentAddress',
        outputs: [{ internalType: 'address', name: 'collection', type: 'address' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'name', type: 'string' },
            { internalType: 'string', name: 'symbol', type: 'string' },
            { internalType: 'string', name: 'tokenURI', type: 'string' },
            { internalType: 'uint32', name: 'maxTokenId', type: 'uint32' },
            { internalType: 'address', name: 'approvedMinter', type: 'address' },
            { internalType: 'uint96', name: 'contractCreationNonce', type: 'uint96' },
            {
                components: [
                    { internalType: 'address', name: 'target', type: 'address' },
                    { internalType: 'bytes', name: 'callData', type: 'bytes' },
                ],
                internalType: 'struct CallWithoutValue',
                name: 'paymentAddressFactoryCall',
                type: 'tuple',
            },
        ],
        name: 'createNFTLimitedEditionCollectionWithPaymentFactory',
        outputs: [{ internalType: 'address', name: 'collection', type: 'address' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'name', type: 'string' },
            { internalType: 'string', name: 'symbol', type: 'string' },
            { internalType: 'string', name: 'tokenURI', type: 'string' },
            { internalType: 'uint256', name: 'mintEndTime', type: 'uint256' },
            { internalType: 'address', name: 'approvedMinter', type: 'address' },
            { internalType: 'uint96', name: 'contractCreationNonce', type: 'uint96' },
        ],
        name: 'createNFTTimedEditionCollection',
        outputs: [{ internalType: 'address', name: 'collection', type: 'address' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'name', type: 'string' },
            { internalType: 'string', name: 'symbol', type: 'string' },
            { internalType: 'string', name: 'tokenURI', type: 'string' },
            { internalType: 'uint256', name: 'mintEndTime', type: 'uint256' },
            { internalType: 'address', name: 'approvedMinter', type: 'address' },
            { internalType: 'uint96', name: 'contractCreationNonce', type: 'uint96' },
            {
                internalType: 'address payable',
                name: 'paymentAddress',
                type: 'address',
            },
        ],
        name: 'createNFTTimedEditionCollectionWithPaymentAddress',
        outputs: [{ internalType: 'address', name: 'collection', type: 'address' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'name', type: 'string' },
            { internalType: 'string', name: 'symbol', type: 'string' },
            { internalType: 'string', name: 'tokenURI', type: 'string' },
            { internalType: 'uint256', name: 'mintEndTime', type: 'uint256' },
            { internalType: 'address', name: 'approvedMinter', type: 'address' },
            { internalType: 'uint96', name: 'contractCreationNonce', type: 'uint96' },
            {
                components: [
                    { internalType: 'address', name: 'target', type: 'address' },
                    { internalType: 'bytes', name: 'callData', type: 'bytes' },
                ],
                internalType: 'struct CallWithoutValue',
                name: 'paymentAddressFactoryCall',
                type: 'tuple',
            },
        ],
        name: 'createNFTTimedEditionCollectionWithPaymentFactory',
        outputs: [{ internalType: 'address', name: 'collection', type: 'address' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getApprovedRouterAddress',
        outputs: [{ internalType: 'address', name: 'router', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'enum CollectionType',
                name: 'collectionType',
                type: 'uint8',
            },
        ],
        name: 'getCollectionTemplateDetails',
        outputs: [
            { internalType: 'address', name: 'implementation', type: 'address' },
            { internalType: 'uint256', name: 'templateVersion', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getCollectionTypeCount',
        outputs: [{ internalType: 'uint256', name: 'count', type: 'uint256' }],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'enum CollectionType',
                name: 'collectionType',
                type: 'uint8',
            },
        ],
        name: 'getCollectionTypeName',
        outputs: [{ internalType: 'string', name: 'typeName', type: 'string' }],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'enum CollectionType',
                name: 'collectionType',
                type: 'uint8',
            },
            { internalType: 'address', name: 'creator', type: 'address' },
            { internalType: 'uint96', name: 'contractCreationNonce', type: 'uint96' },
        ],
        name: 'predictCollectionAddress',
        outputs: [{ internalType: 'address', name: 'collection', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
];
//# sourceMappingURL=NFTCollectionFactory.generated.js.map